import { Button } from '@mui/material';
import { ClearIcon } from '@mui/x-date-pickers';
import { useQueryStates } from 'nuqs';
import { useIntl } from 'react-intl';
import { useListViewContext } from '../context/ListViewContext';

/**
 * Reset filters button component that clears all filters and resets page to 0.
 * Uses resetFilters from context so the update is atomic (filters + pageIndex) with ListView's URL state.
 */
export function ResetFiltersButton({ onReset }: { onReset?: () => void }) {
  const { $t } = useIntl();
  const { filters, parsers, resetFilters } = useListViewContext();

  // Read-only: parsers contain only filter keys; used to know if any filter is set
  const [currentFilters] = useQueryStates(parsers);

  // Check if any filter is set (non-null, non-undefined, non-empty)
  const hasAnyFilterSet = filters.some((filter) => {
    const value = (currentFilters as Record<string, any>)[filter.name];
    return value !== null && value !== undefined && value !== '';
  });

  const isEnabled = hasAnyFilterSet;

  const handleReset = () => {
    resetFilters();
    if (onReset) {
      onReset();
    }
  };

  return (
    <Button
      size="small"
      variant="outlined"
      color="secondary"
      startIcon={<ClearIcon />}
      onClick={handleReset}
      disabled={!isEnabled}
    >
      {$t({
        id: 'common.actions.resetFilters',
        defaultMessage: 'Limpiar',
      })}
    </Button>
  );
}
